exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__EmptyPanel__emptyTitle__4mDIH {\n  background-color: #f6f6f6;\n  border-radius: 100px;\n  height: 22px;\n  margin: 0;\n  width: 126px;\n}\n\n.dmb-web__EmptyPanel__smallerHeight__8TahX {\n  height: 13px;\n}\n\n.dmb-web__EmptyPanel__smallerWidth__xvbtY {\n  margin: 9px 0 0;\n  width: 88px;\n}\n\n.dmb-web__EmptyPanel__card__5-AAk {\n  background-color: white;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 1px 4px 0 rgb(0 0 0 / 21%);\n          box-shadow: 0 1px 4px 0 rgb(0 0 0 / 21%);\n  height: 59px;\n  margin: 10px;\n  padding: 16px;\n  width: calc(100% - 20px);\n}\n", ""]);

// exports
exports.locals = {
	"emptyTitle": "dmb-web__EmptyPanel__emptyTitle__4mDIH",
	"smallerHeight": "dmb-web__EmptyPanel__smallerHeight__8TahX",
	"smallerWidth": "dmb-web__EmptyPanel__smallerWidth__xvbtY",
	"card": "dmb-web__EmptyPanel__card__5-AAk"
};